import { render, staticRenderFns } from "./udatalists3.vue?vue&type=template&id=5c31f5da&scoped=true&"
import script from "./udatalists3.vue?vue&type=script&lang=js&"
export * from "./udatalists3.vue?vue&type=script&lang=js&"
import style0 from "./udatalists3.vue?vue&type=style&index=0&id=5c31f5da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c31f5da",
  null
  
)

export default component.exports